import styled from 'styled-components';

export const CheckboxContainer = styled.div`
    display: flex;
    align-items: center;
`;

export const StyledCheckbox = styled.button`
    display: flex;
    align-items: center;
    justify-content: center;

    width: 1.5rem;
    height: 1.5rem;
    background: ${({ theme }) => theme.colors['neutral-400-opacity']};
    color: ${({ theme }) => theme.colors['neutral-800']};
    border-radius: 0.35rem;
    transition: background 0.3s;
    cursor: pointer;

    svg {
        width: 1.5rem;
        height: 1.25rem;
        stroke-width: 2.5;
        opacity: 0;
        transition:
            opacity 0.1s,
            transform 0.1s;
        color: ${({ theme }) => theme.colors['neutral-0']};
        transform: scale(0.5);
        /* background-color: red; */
        /* margin: auto; */
    }

    &[aria-checked='true'] {
        background: ${({ theme }) => theme.colors['supernova-500']};

        svg {
            opacity: 1;
            transform: scale(1);
        }
    }
    border: none;
`;

export const Label = styled.label`
    margin-left: 0.5rem;
    font-size: 1rem;
    color: ${({ theme }) => theme.colors['neutral-800']};
`;
